module.exports = __webpack_public_path__ + "13e2cf546ed4dcabd3159738addc701c.fbx";